import React from "react";

// eslint-disable-next-line import/no-unresolved
import { Analytics } from "@vercel/analytics/react";

import Gtag from "./Gtag";

const AnalyticsWrapper = () => (
    <>
        <Gtag />
        <Analytics />
    </>
);

export default AnalyticsWrapper;
